<template>
  <div class="school-home-page">
    <div class="frame">
      <div
        class="menu"
        style="background: #fff
          ;"
      >
        <el-row>
          <el-col :span="24">
            <div class="logo_wrapper">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark">
                    <!-- 头像挂件 -->
                    <img
                      class="title-url"
                      v-if="$store.state.resource.titleUrl"
                      :src="$store.state.resource.titleUrl"
                      alt=""
                    />
                    <el-image
                      class="logo_img"
                      :src="$store.state.user.userInfo.headimgUrl"
                      fit="fill"
                    ></el-image>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="logo_name">
                    <el-tooltip
                      effect="dark"
                      :content="'账号:' + $store.state.user.userInfo.name"
                      placement="top-start"
                    >
                      <span>
                        {{
                          $store.state.user.userInfo.realName &&
                          $store.state.user.userInfo.realName.length > 4
                            ? $store.state.user.userInfo.realName.slice(0, 4) +
                              '...'
                            : $store.state.user.userInfo.realName
                        }}
                      </span>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="logo_school">
                    <span style="color: #707070">
                      {{ $store.state.user.schoolInfo.name }}
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <el-menu
          :default-active="activeMenu"
          class="el-menu-demo"
          background-color="#ffffff"
          text-color="#383838"
          active-text-color="#383838"
        >
          <el-menu-item
            index="practice-list"
            @click="$router.push({ name: 'practice-list' })"
          >
            <i
              style="margin-left: 20px; font-size: 22px"
              class="el-icon-files"
            ></i>
            <span style="margin-left: 10px; font-size: 16px" slot="title"
              >我的练习</span
            >
          </el-menu-item>
          <!-- <el-submenu index="stupractices">
            <template slot="title">
              <i
                style="margin-left: 20px; font-size: 22px"
                class="el-icon-files"
              ></i>
              <span style="margin-left: 10px;font-size: 16px">我的练习</span>
            </template>
            <el-menu-item
              index="practice-list"
              @click="$router.push({ name: 'practice-list' })"
              ><span style="margin-left: 40px">进行中</span></el-menu-item
            >
            <el-menu-item
              index="practice-offlist"
              @click="$router.push({ name: 'practice-offlist' })"
              ><span style="margin-left: 40px">已结束</span></el-menu-item
            >
          </el-submenu> -->

          <el-menu-item
            index="exam-list"
            @click="$router.push({ name: 'exam-list' })"
          >
            <i
              style="margin-left: 20px; font-size: 22px"
              class="el-icon-document"
            ></i>
            <span style="margin-left: 10px; font-size: 16px" slot="title"
              >我的考试</span
            >
          </el-menu-item>
          <!-- <el-submenu index="stuexams">
            <template slot="title">
              <i
                style="margin-left: 20px; font-size: 22px"
                class="el-icon-document"
              ></i>
              <span style="margin-left: 10px;font-size: 16px">我的考试</span>
            </template>

            <el-menu-item
              index="exam-list"
              @click="$router.push({ name: 'exam-list' })"
              ><span style="margin-left: 40px">进行中</span></el-menu-item
            >

            <el-menu-item
              index="exam-offlist"
              @click="$router.push({ name: 'exam-offlist' })"
              ><span style="margin-left: 40px">已结束</span></el-menu-item
            >
          </el-submenu> -->
          <el-menu-item
            index="question-book"
            @click="$router.push({ name: 'question-book' })"
          >
            <i
              style="margin-left: 20px; font-size: 22px"
              class="el-icon-notebook-1"
            ></i>
            <span style="margin-left: 10px; font-size: 16px" slot="title"
              >错题本</span
            >
          </el-menu-item>
          <!--
          <el-menu-item
            index="4"
            @click="$router.push({ name: 'classlistIndexTeacher' })"
          >
            <i class="el-icon-s-marketing"></i>
            <span slot="title">任务管理</span>
          </el-menu-item>
-->
        </el-menu>
      </div>
      <section>
        <container :classData="classData"></container>
      </section>
    </div>
  </div>
</template>

<script>
import container from './container'

// import { getTchIndexInfo } from "@/api/classroom/teacher_api";

export default {
  name: 'exam-stu',
  components: {
    container,
  },
  data() {
    return {
      nickName: '', //教师名字
      schoolName: '', //学校名称
      classData: {},
    }
  },

  computed: {
    activeMenu() {
      const route = this.$route
      const { meta, name } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return name
    },
  },

  mounted() {
    document.getElementById('home_top').style.display = 'block'
    document.getElementById('home_bottom').style.display = 'none'

    //获取教师数据
    console.log('获取教师数据')

    // getTchIndexInfo().then((res) => {
    //   console.log(res);
    //   this.classData = res;
    // });
  },

  methods: {},
}
</script>

<style>
.el-submenu {
  /* min-width: 220px; */
}
</style>

<style scoped lang="scss">
::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.school-home-page {
  height: calc(100% - 60px);
  background-color: #f2f2f2;

  .logo_wrapper {
    position: relative;
    width: 220px;
    height: 250px;
    background: #ffffff;
    color: #707070;
    .title-url {
      position: absolute;
      z-index: 2;
      width: 220px;
      left: 0px;
      top: 0px;
    }
    .logo_img {
      position: relative;
      z-index: 1;
      border-radius: 50%;
      width: 100px;
      height: 100px;
      margin-left: 60px;
      margin-top: 60px;
    }

    .logo_name {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      margin-top: 10px;
    }

    .logo_school {
      text-align: center;
    }
  }

  .frame {
    display: flex;
    width: 100%;
    height: 100%;
    background: #f1f7fe;

    .menu {
      position: relative;
      z-index: 12;
      overflow-y: auto;
      // box-shadow: 0 -8px 10px 2px #dedee3;
      min-width: 220px;

      header {
        height: 30px;
      }

      .header-title {
        padding: 5px 0;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
      }

      .el-menu-demo:not(.el-menu--collapse) {
        width: 220px;
      }

      .el-menu-demo {
        height: calc(100% - 250px);
        border: 0px;
      }

      .el-submenu {
        // min-width: 220px;
      }

      .el-menu-item {
        // min-width: 220px;
      }

      .el-menu-item.is-active {
        background-color: #e1edff !important;
      }

      /deep/.el-menu-demo .el-submenu {
        margin-left: 10px !important;
        margin-right: 10px !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        border-radius: 10px !important;
        min-width: auto;
        line-height: 50px !important;
      }

      /deep/.el-menu-demo .el-menu-item {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        border-radius: 10px !important;
      }

      /deep/.el-menu .el-menu-item:hover {
        outline: 0 !important;
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }

      /deep/.el-menu .el-menu-item.is-active {
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }

      .el-submenu /deep/.el-submenu__title:hover {
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }
    }

    section {
      flex: 1;
      overflow: auto;
    }
  }
}
</style>
